// extracted by mini-css-extract-plugin
export default {"emptyText":"styles_emptyText__UClDU"};